<svg class="app-spinner-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" focusable="false">
  <circle class="app-spinner-circle" cx="50" cy="50" r="45" fill="none" [attr.stroke-width]="viewBoxStrokeWidth" />
</svg>
